export default __webpack_public_path__ + "static/media/avatar.a7c40a0d.jpg";